import AppPagePlanDetailsCollapsible from 'tio-employee/components/app/page/plan-details-collapsible';

const sections = [
  {
    title: 'questions_you_have.repayment_plans.keep_in_mind',
    description: 'questions_you_have.repayment_plans.income_driven.keep_in_mind',
  },
  {
    title: 'questions_you_have.repayment_plans.make_the_switch.title',
    description: 'questions_you_have.repayment_plans.make_the_switch.description',
  },
  {
    title: 'questions_you_have.repayment_plans.need_more_help.title',
    description: 'questions_you_have.repayment_plans.need_more_help.description',
  },
];

// PAYE Section Data
const payeTitle = 'questions_you_have.repayment_plans.income_driven.paye.title';
const payeDescription = 'questions_you_have.repayment_plans.income_driven.paye.description';
const payeDetails = [
  {
    title: 'questions_you_have.repayment_plans.eligible_loan_types',
    description: 'questions_you_have.repayment_plans.income_driven.paye.eligible_loan_types',
  },
  {
    title: 'questions_you_have.repayment_plans.years_to_repay',
    description: 'questions_you_have.repayment_plans.income_driven.paye.years_to_repay',
  },
  {
    title: 'questions_you_have.repayment_plans.loan_forgiveness',
    description: 'questions_you_have.repayment_plans.income_driven.paye.loan_forgiveness',
  },
  {
    title: 'questions_you_have.repayment_plans.monthly_payment',
    description: 'questions_you_have.repayment_plans.income_driven.paye.monthly_payment',
  },
];
const payePros = [
  'questions_you_have.repayment_plans.income_driven.paye.pro_1',
  'questions_you_have.repayment_plans.income_driven.paye.pro_2',
];
const payeCons = [
  'questions_you_have.repayment_plans.income_driven.paye.con_1',
  'questions_you_have.repayment_plans.income_driven.paye.con_2',
];

// Income-Based Section Data
const basedTitle = 'questions_you_have.repayment_plans.income_driven.based.title';
const basedDescription = 'questions_you_have.repayment_plans.income_driven.based.description';
const basedDetails = [
  {
    title: 'questions_you_have.repayment_plans.eligible_loan_types',
    description: 'questions_you_have.repayment_plans.income_driven.based.eligible_loan_types',
  },
  {
    title: 'questions_you_have.repayment_plans.years_to_repay',
    description: 'questions_you_have.repayment_plans.income_driven.based.years_to_repay',
  },
  {
    title: 'questions_you_have.repayment_plans.loan_forgiveness',
    description: 'questions_you_have.repayment_plans.income_driven.based.loan_forgiveness',
  },
  {
    title: 'questions_you_have.repayment_plans.monthly_payment',
    description: 'questions_you_have.repayment_plans.income_driven.based.monthly_payment',
  },
];
const basedPros = [
  'questions_you_have.repayment_plans.income_driven.based.pro_1',
  'questions_you_have.repayment_plans.income_driven.based.pro_2',
  'questions_you_have.repayment_plans.income_driven.based.pro_3',
];
const basedCons = [
  'questions_you_have.repayment_plans.income_driven.based.con_1',
  'questions_you_have.repayment_plans.income_driven.based.con_2',
];

// Income-Contingent Section Data
const contingentTitle = 'questions_you_have.repayment_plans.income_driven.contingent.title';
const contingentDescription =
  'questions_you_have.repayment_plans.income_driven.contingent.description';
const contingentDetails = [
  {
    title: 'questions_you_have.repayment_plans.eligible_loan_types',
    description: 'questions_you_have.repayment_plans.income_driven.contingent.eligible_loan_types',
  },
  {
    title: 'questions_you_have.repayment_plans.years_to_repay',
    description: 'questions_you_have.repayment_plans.income_driven.contingent.years_to_repay',
  },
  {
    title: 'questions_you_have.repayment_plans.loan_forgiveness',
    description: 'questions_you_have.repayment_plans.income_driven.contingent.loan_forgiveness',
  },
  {
    title: 'questions_you_have.repayment_plans.monthly_payment',
    description: 'questions_you_have.repayment_plans.income_driven.contingent.monthly_payment',
  },
];
const contingentPros = [
  'questions_you_have.repayment_plans.income_driven.contingent.pro_1',
  'questions_you_have.repayment_plans.income_driven.contingent.pro_2',
  'questions_you_have.repayment_plans.income_driven.contingent.pro_3',
];
const contingentCons = [
  'questions_you_have.repayment_plans.income_driven.contingent.con_1',
  'questions_you_have.repayment_plans.income_driven.contingent.con_2',
];

<template>
  <div>
    <AppPagePlanDetailsCollapsible
      @title={{payeTitle}}
      @description={{payeDescription}}
      @details={{payeDetails}}
      @pros={{payePros}}
      @cons={{payeCons}}
      @moreSections={{sections}}
    />
    <AppPagePlanDetailsCollapsible
      @title={{basedTitle}}
      @description={{basedDescription}}
      @details={{basedDetails}}
      @pros={{basedPros}}
      @cons={{basedCons}}
      @moreSections={{sections}}
    />
    <AppPagePlanDetailsCollapsible
      @title={{contingentTitle}}
      @description={{contingentDescription}}
      @details={{contingentDetails}}
      @pros={{contingentPros}}
      @cons={{contingentCons}}
      @moreSections={{sections}}
    />
  </div>
</template>
